import React from 'react'
import { ROW_H, SUMMARY_H } from '../../lib/constants'

export interface SummaryBarProps {
  x: number
  width: number
  rowTop: number
  label: string
  percent: number
  selected: boolean
  shiftUp: boolean
  onPointerEnter?: (e: React.PointerEvent) => void
  onPointerLeave?: () => void
  onClick?: (e: React.MouseEvent) => void
}

const CAP_HALF_W = 4
const CAP_H = 6

/** MS Project style bracket for `isSummary` rows. Spec B §8.4. */
const SummaryBar: React.FC<SummaryBarProps> = ({ x, width, rowTop, label, percent, selected, shiftUp, onPointerEnter, onPointerLeave, onClick }) => {
  const y = rowTop + (ROW_H - SUMMARY_H) / 2 - (shiftUp ? 4 : 0)
  const w = Math.max(2, width)
  const capY = y + SUMMARY_H
  const leftCap = `${x - CAP_HALF_W},${capY} ${x + CAP_HALF_W},${capY} ${x},${capY + CAP_H}`
  const rightCap = `${x + w - CAP_HALF_W},${capY} ${x + w + CAP_HALF_W},${capY} ${x + w},${capY + CAP_H}`
  return (
    <g data-bar data-summary onPointerEnter={onPointerEnter} onPointerLeave={onPointerLeave} onClick={onClick} className="cursor-pointer">
      <rect x={x} y={y} width={w} height={SUMMARY_H} className="fill-foreground" />
      {percent > 0 && <rect x={x} y={y} width={(w * Math.min(100, percent)) / 100} height={SUMMARY_H} className="fill-white/30" />}
      <polygon points={leftCap} className="fill-foreground" />
      <polygon points={rightCap} className="fill-foreground" />
      {selected && <rect x={x - 1} y={y - 1} width={w + 2} height={SUMMARY_H + CAP_H + 2} rx={2} className="fill-none stroke-primary stroke-2" />}
      <text x={x + w + 6} y={y + SUMMARY_H / 2} dominantBaseline="middle" className="text-xs font-medium fill-foreground pointer-events-none select-none">{label}</text>
    </g>
  )
}

export default SummaryBar
